import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0d101d59 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _52e70811 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _79a27234 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _282f7d2c = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _0b457e0a = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _47f1442c = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _4b9d102c = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _55f71e45 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _5f0ba70e = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _8be6e2a2 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _496cbc43 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _2f399aa6 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _1f1dc60a = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _c9c37dfc = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _0b340726 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _4fc7dc14 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _9537516c = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _698997d1 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _6acce731 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _2c985c18 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _0969e330 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _748ae11c = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _4b7c4bd1 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _d5133752 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _7afc452e = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _20af0552 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _3fd65230 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _5f6a7290 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _6963bcef = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _4ec7543e = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _0183cb6a = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _61fd0983 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _1179ca85 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _8423ef82 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _641288cc = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _09f01db8 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _728513cc = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _f7b9d2d4 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7d18d2d4 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _343538bc = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _6fb958dd = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _f91f3a20 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _cca5ce1a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _5c65d93f = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _13421ee9 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _6bce40fa = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _4e5b876a = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _6465ff89 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _27592fd0 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _75fd9cd0 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _aa005b72 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _813a928e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _af752828 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _5a2898d1 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _465be1f2 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _c96f8ea6 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _8f9dfe50 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _61880883 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _79f24767 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _0882343a = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _63943373 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _ad94deaa = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _2752dc82 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _3ef0bbfe = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _00611cc8 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _7be826e6 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _1d610a1c = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _5857d614 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _2b1a192a = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _f4bc95ba = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _7d041a37 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _4fce71e5 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _479dd8b3 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _3a87fc55 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _0d101d59,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _52e70811,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _79a27234,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _282f7d2c,
    name: "calendar"
  }, {
    path: "/customer",
    component: _0b457e0a,
    name: "customer"
  }, {
    path: "/details",
    component: _47f1442c,
    name: "details"
  }, {
    path: "/goals",
    component: _4b9d102c,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _55f71e45,
    name: "maisoku"
  }, {
    path: "/media",
    component: _5f0ba70e,
    name: "media"
  }, {
    path: "/privacy",
    component: _8be6e2a2,
    name: "privacy"
  }, {
    path: "/project",
    component: _496cbc43,
    name: "project"
  }, {
    path: "/response",
    component: _2f399aa6,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _1f1dc60a,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _c9c37dfc,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _0b340726,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _4fc7dc14,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _9537516c,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _698997d1,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _6acce731,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _2c985c18,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _0969e330,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _748ae11c,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _4b7c4bd1,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _d5133752,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _7afc452e,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _20af0552,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _3fd65230,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _5f6a7290,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _6963bcef,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _4ec7543e,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _0183cb6a,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _61fd0983,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _1179ca85,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _8423ef82,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _641288cc,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _09f01db8,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _728513cc,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _f7b9d2d4,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7d18d2d4,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _343538bc,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _6fb958dd,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _f91f3a20,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _cca5ce1a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _5c65d93f,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _13421ee9,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _6bce40fa,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _4e5b876a,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _6465ff89,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _27592fd0,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _75fd9cd0,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _aa005b72,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _813a928e,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _af752828,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _5a2898d1,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _465be1f2,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _c96f8ea6,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _8f9dfe50,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _61880883,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _79f24767,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _0882343a,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _63943373,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _ad94deaa,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _2752dc82,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _3ef0bbfe,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _00611cc8,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _7be826e6,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _1d610a1c,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _5857d614,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _2b1a192a,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _f4bc95ba,
    name: "property-property",
    children: [{
      path: "contact",
      component: _7d041a37,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _4fce71e5,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _479dd8b3,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _3a87fc55,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
